"use client";

import { FlagQuery, OpenFeature, useFlag as useOpenFeatureFlag } from "@openfeature/react-sdk";
import { UnleashWebProvider } from "@openfeature/unleash-web-provider";

import { env } from "~/env";
import { NoopWebProvider } from "./noop-web-provider";
import { FLAGS, FlagType } from "./provider";

export type { FlagType };

export const providerWeb = env.NEXT_PUBLIC_UNLEASH_URL
  ? new UnleashWebProvider({
      url: `${env.NEXT_PUBLIC_UNLEASH_URL}/api/frontend/`,
      clientKey: env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_KEY ?? "",
      appName: "tenki",
      environment: env.NEXT_PUBLIC_UNLEASH_ENVIRONMENT ?? "development",
    })
  : new NoopWebProvider();

OpenFeature.setProvider(providerWeb);

export function useFlag(flag: FlagType, defaultValue?: boolean): FlagQuery<boolean> {
  const [f, defaultVal] = FLAGS[flag] ?? [];
  const flags: [string, boolean] = f ? [f, defaultValue ?? defaultVal] : [flag, defaultValue ?? true];
  return useOpenFeatureFlag(...flags);
}

export function Flag({
  flag,
  children,
  defaultValue,
}: {
  children: React.ReactNode;
  flag?: FlagType;
  defaultValue?: boolean;
}) {
  if (!flag) return children;
  return (
    <FlagComponent flag={flag} defaultValue={defaultValue}>
      {children}
    </FlagComponent>
  );
}

export function FlagComponent({
  flag,
  children,
  defaultValue,
}: {
  children: React.ReactNode;
  flag: FlagType;
  defaultValue?: boolean;
}) {
  const { value } = useFlag(flag, defaultValue);
  if (!value) return null;
  return children;
}
